/* eslint-disable no-var */
import React, { useState, useEffect } from 'react'
import logo from '../images/logo.png'
import { Link } from 'react-scroll'
import { Link as MyLink } from 'react-router-dom'

const PrimaryHeader = () => {
  const [transition, setTransition] = useState('translate-x-full')
  const [home, setHome] = useState('w-full')
  const [about, setAbout] = useState('w-0')
  const [contact, setContact] = useState('w-0')

  const page = () => {
    if (window.pageYOffset >= 0) {
      setHome('w-full')
      setContact('w-0')
      setAbout('w-0')
    }
    if (window.pageYOffset >= 838) {
      setHome('w-0')
      setContact('w-0')
      setAbout('w-full')
    }
    if (window.pageYOffset >= 1670) {
      setHome('w-0')
      setContact('w-full')
      setAbout('w-0')
    }
  }
  const handleSideMenu = () => {
    transition === 'translate-x-full'
      ? setTransition('translate-x-0')
      : setTransition('translate-x-full')
  }

  useEffect(() => {
    document.addEventListener('scroll', page)
    return () => document.removeEventListener('scroll', page)
  }, [])

  return (
    <div>
      <div className='text-sm fixed top-0 z-50 flex flex-col'>
        <div className='fixed flex flex-col items-center bg-gray-50 md:mb-0 w-full'>
          <div
            style={{ color: '#212529' }}
            className='flex flex-row border-b-2 border-gray-100 items-center pl-0 py-4 justify-between w-full px-6 md:px-15 lg:px-32 xl:px-44 xxl:px-52'
          >
            <MyLink to='/'><img className='w-64' src={logo} alt='logo' /></MyLink>

            <div className='hidden md:flex font-bold justify-between xxl:mr-32'>
              <ul className='justify-start gap-x-5 items-center pl-2 flex flex-row font-bold'>
                <li className='group cursor-pointer flex flex-col w-max'>
                  <Link
                    className='text-gray-700'
                    activeClass='active'
                    to='home'
                    spy
                    smooth
                    offset={-0}
                    duration={500}
                  >
                    HOME
                  </Link>
                  <div
                    className={`h-0.5 ${home} group-hover:w-full bg-blue-500 mx-auto transition-all duration-300 `}
                  ></div>
                </li>
                <li className='group cursor-pointer flex flex-col w-max'>
                  <Link
                    className='text-gray-700'
                    activeClass='about'
                    to='about'
                    spy
                    smooth
                    offset={-95}
                    duration={500}
                  >
                    ABOUT
                  </Link>
                  <div
                    className={`h-0.5 ${about} group-hover:w-full bg-blue-500 mx-auto transition-all duration-300 `}
                  ></div>
                </li>
                <li className='group cursor-pointer flex flex-col w-max'>
                  <Link
                    className='text-gray-700'
                    activeClass='active'
                    to='contact'
                    spy
                    smooth
                    offset={-95}
                    duration={500}
                  >
                    CONTACT US
                  </Link>
                  <div
                    className={`h-0.5 ${contact} group-hover:w-full bg-blue-500 mx-auto transition-all duration-300 `}
                  ></div>
                </li>
                <li className='group cursor-pointer flex flex-col w-max'>
                  <a href='https://www.mxwireless.com/shop' className='text-gray-700 cursor-pointer'>
                    SHOP
                  </a>
                  <div className='h-0.5 group-hover:w-full bg-blue-500 mx-auto transition-all duration-300 '></div>
                </li>
                <li className='flex flex-col items-center'>
                  <i className='ml-8 text-2xl fab fa-facebook-f scale-105 hover:scale-150 transition-all duration-500'></i>
                </li>
                <li className='flex flex-col items-center'>
                  <i className='text-2xl 	fab fa-twitter scale-105 hover:scale-150 transition-all duration-500'></i>
                </li>
                <li className='flex flex-col items-center'>
                  <i className='text-2xl fa fa-instagram scale-105 hover:scale-150 transition-all duration-500'></i>
                </li>
              </ul>
            </div>
            <button onClick={() => handleSideMenu()} className='md:hidden'>
              <i className='fa fa-bars scale-150'></i>
            </button>
            <div
              className={`fixed h-screen w-4/5 sm:w-3/5 ${transition} bg-blue-500 md:hidden duration-500 ease-in-out transition-all right-0 text-gray-200 top-17`}
            >
              <div
                onClick={() => setTransition('translate-x-full')}
                className='bg-blue-500 absolute right-0 top-0 p-1 m-2 cursor-pointer'
              >
                <i className=' fa fa-close scale-105 float-right'></i>
              </div>
              <div className='flex justify-between mx-6 mb-6 mt-20'>
                <div className='flex flex-col items-center scale-125 hover:scale-150 transition-all duration-500 cursor-pointer'>
                  <p className='text-xs'>Search</p>
                  <i className='fa fa-search'></i>
                </div>
                <div className='flex flex-col items-center scale-125 hover:scale-150 transition-all duration-500 cursor-pointer'>
                  <p className='text-xs'>My Wishlist</p>
                  <i className='fa fa-heart'></i>
                </div>
                <div className='flex flex-col items-center scale-125 hover:scale-150 transition-all duration-500 cursor-pointer'>
                  <p className='text-xs'>My Cart</p>
                  <i className='fa fa-shopping-cart'></i>
                </div>
              </div>
              <ul className='flex flex-col gap-y-1 items-center'>
                <MyLink
                  to='/'
                  className='item pt-4 border-b-2 font-bold transition-all duration-100 border-red-500'
                >
                  Home
                </MyLink>
                <li className='item pt-4 font-bold hover:border-b-2 transition-all duration-100 border-red-500'>
                  <Link activeClass='active' to='about' spy smooth offset={-110} duration={500}>
                    About
                  </Link>
                </li>
                <li className='item pt-4 font-bold hover:border-b-2 transition-all duration-100 border-red-500'>
                  <Link activeClass='active' to='contact' spy smooth offset={-110} duration={500}>
                    Contact Us
                  </Link>
                </li>
                <li className='item pt-4 font-bold hover:border-b-2 transition-all duration-100 border-red-500'>
                  <div className='cursor-pointer'>Shop</div>
                </li>
              </ul>
              <div className='flex justify-around mx-6 mt-20'>
                <div className='flex flex-col items-center'>
                  <i className='	fab fa-facebook-f scale-125 hover:scale-150 transition-all duration-500'></i>
                </div>
                <div className='flex flex-col items-center'>
                  <i className='fab fa-linkedin-in scale-125 hover:scale-150 transition-all duration-500'></i>
                </div>
                <div className='flex flex-col items-center'>
                  <i className='	fab fa-twitter scale-125 hover:scale-150 transition-all duration-500'></i>
                </div>
                <div className='flex flex-col items-center'>
                  <i className='fa fa-instagram scale-125 hover:scale-150 transition-all duration-500'></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrimaryHeader
